import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class FlatpickrController extends Controller {
  static values = {
    type: String
  }

  connect() {
    if (bootstrap.Modal.prototype._enforceFocus) {
      bootstrap.Modal.prototype._enforceFocus = function () { }
    }

    const lockTimeInputs = (instance) => {
      const timeInputs = [instance.hourElement, instance.minuteElement, instance.secondElement]
        .filter(Boolean)

      for (const input of timeInputs) {
        input.setAttribute("readonly", "readonly")
        input.setAttribute("inputmode", "none")
        input.style.caretColor = "transparent"
      }
    }

    const showConfirmButton = this.typeValue === "datetime"

    let config = {
      disableMobile: true,
      allowInput: false,
      appendTo: document.body,

      onOpen: (selectedDates, dateStr, instance) => {
        if (instance.config.enableTime) {
          lockTimeInputs(instance)
        }
      },

      onClose: () => {
      },

      onReady: function (selectedDates, dateStr, instance) {
        const calendarClass = this.element.dataset.flatpickrCalendarClass
        if (calendarClass) {
          instance.calendarContainer.classList.add(calendarClass)
        }

        if (showConfirmButton) {
          const confirmButton = document.createElement("button")
          confirmButton.type = "button"
          confirmButton.className = "btn w-100 rounded-0 bg-black text-white p-font-bold flatpickr-confirm-button"
          confirmButton.textContent = "Done"
          confirmButton.addEventListener("click", () => instance.close())
          instance.calendarContainer.appendChild(confirmButton)
        }

        if (!instance.config.enableTime) return

        lockTimeInputs(instance)

        const inputs = [instance.hourElement, instance.minuteElement].filter(Boolean)

        for (const [index, input] of inputs.entries()) {
          input.addEventListener("input", function () {
            input.value = input.value.replaceAll(/\D/g, "").slice(0, 2)
          })

          input.addEventListener("blur", function () {
            if (input.value === "") return

            let max = index === 0 ? 23 : 59
            let val = Number.parseInt(input.value, 10)

            val = Math.min(max, Math.max(0, val))

            input.value = val.toString().padStart(2, "0")
          })
        }
      }
    }

    if (this.typeValue === "time") {
      Object.assign(config, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        altInput: true,
        altFormat: "H:i",
        minuteIncrement: 1
      })
    } else if (this.typeValue === "customtime") {
      Object.assign(config, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "h:i K",
        time_24hr: false,
        altInput: true,
        altFormat: "h:i K",
        minuteIncrement: 1
      })
    } else if (this.typeValue === "datetime") {
      Object.assign(config, {
        enableTime: true,
        dateFormat: "Y-m-d h:i K",
        time_24hr: false
      })
    } else {
      Object.assign(config, {
        dateFormat: "Y-m-d"
      })
    }

    this.fp = flatpickr(this.element, config)
  }

  disconnect() {
    document.body.classList.remove("flatpickr-open")
    this.fp?.destroy()
  }
}
